import React, {FunctionComponent, useContext} from 'react';
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import {AutoLinkWrapper} from "@flicent/fieldpulse-react-component-library-frontend";
import "./NotesSection.scss"

export const NotesSection: FunctionComponent = () => {
    const invoice: Invoice = useContext(InvoiceContext);

    return (
        <section className='basic-section notes-section'>
            <h3>Notes</h3>

            <AutoLinkWrapper>
                <p className='notes'>{invoice.notes}</p>
            </AutoLinkWrapper>
        </section>
    );
};
